<template>
  <div class="remaining-day-wrapper">
    <i18n path="promotion.referFriends.daysRemaining">
      <template v-slot:day>
        {{ remainingTime }}
      </template>
    </i18n>
  </div>
</template>

<script>
export default {
  name: 'RemainingDay',
  props: ['remainingTime']
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/referFriends/referrals/remainingDay.scss';
</style>
